export default __webpack_public_path__ + "static/icon-c9d327711aad9ec978d0524b79fefdc7.png";